import React from "react";
import MenuAdrienCachot from "../../LandingMenu/MenuAdrienCachot/MenuAdrienCachot";
import { ILandingFooterProps } from "../LandingFooter";

import FlexBox from "../../../FlexBox/FlexBox";
import Typography from "../../../../Foundation/Typography/Typography";
import StyledDiv from "../../../StyledDiv/StyledDiv";
import SectionContainer from "../../../../Core/SectionContainer/SectionContainer";
import { footerAdrienCachotIcons } from "./FooterAdrienCachot.icons";
import GradientSocialIcons from "./GradientSocialIcons/GradientSocialIcons";
import htmlParse from "html-react-parser";

interface IFooterAdrienCachotProps extends Omit<ILandingFooterProps, "title"> {
  title?: string;
  linkText?: string;
  onClick?: () => void;
}

const FooterAdrienCachot = (props: IFooterAdrienCachotProps) => {
  const { title, linkText, onClick, footerText, ...landingFooterProps } = props;
  return (
    <StyledDiv
      styles={{
        backgroundImage: `url(${landingFooterProps.backgroundImage?.desktop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        mixBlendMode: "exclusion",
        mobile: {
          backgroundImage: `url(${landingFooterProps.backgroundImage?.mobile})`,
        },
        overflow: "hidden",
        paddingBottom: 66,
      }}
    >
      <StyledDiv as={SectionContainer}>
        <StyledDiv>
          <StyledDiv
            styles={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "704px",
              mobile: {
                alignItems: "flex-start",
                minHeight: "504px",
              },
            }}
          >
            {/* MENU */}
            <StyledDiv
              as={MenuAdrienCachot}
              title={title}
              linkText={linkText}
              onClick={onClick}
              styles={{
                transform: "translate(18%, -5%)",
                mobile: {
                  transform: "translate(0%, 0%)",
                  padding: "0 !important",
                },
              }}
            />
          </StyledDiv>

          {/* SOCIAL ICONS */}

          <StyledDiv
            as={FlexBox}
            styles={{
              margin: "0 auto",
              justifyContent: "center",
              mobile: {
                paddingTop: "56px",
              },
            }}
          >
            <FlexBox
              direction="column"
              justify="center"
              align="center"
              gap={20}
            >
              {/* logo */}
              <StyledDiv styles={{ marginBottom: 12 }}>
                {footerAdrienCachotIcons.logo}
              </StyledDiv>
              <Typography
                align="center"
                variant="adriencachotBody2"
                color="white"
              >
                {landingFooterProps.socialNetworkLabel}
              </Typography>
              {landingFooterProps.socialLinks && (
                <GradientSocialIcons
                  socialLinks={landingFooterProps.socialLinks}
                />
              )}

              {footerText && (
                <StyledDiv as={Typography}
                  align="center"
                  variant="adriencachotBody2"
                  color="white"
                  styles={{
                    maxWidth: 680,
                    margin: "35px auto 0",
                  }}
                >
                  {htmlParse(footerText)}
                </StyledDiv>
              )}
            </FlexBox>
          </StyledDiv>
        </StyledDiv>
      </StyledDiv>
    </StyledDiv>
  );
};

export default FooterAdrienCachot;
